 
import React from 'react';
import './../styles/sectioninfo.scss';

const ProductImage = ({colorId, attributes, altText, defaultImage}) => {
    let path = defaultImage;

    function getImagePath(colorId) {
        const attribute = attributes.find(item => item.attributeValueId === colorId);
        return attribute ? attribute.availableImage : defaultImage;
    }

    if (colorId && attributes) {
        path = getImagePath(colorId);
    }

    return (
        <div className="product-image">
            <img src={`https://img.smartpak.com/images/product/highres/${path}?width=750`} alt={`${altText} image`} />
        </div>
    );
};

export default ProductImage;
